<section *ngIf="currentLesson" class="profile-results">
  <div class="profile-results__lesson-pagination">
    <mat-icon class="profile-results__lesson-pagination__nav" [class.active-nav]="isActivePrevNav"
              (click)="prevLesson()">arrow_left</mat-icon>
    <div class="profile-results__lesson-pagination__info">
      <span>Занятие № {{ currentLesson.lesson_number }}</span>
      <span>{{ currentLesson.date | date }}</span>
    </div>
    <mat-icon class="profile-results__lesson-pagination__nav" [class.active-nav]="isActiveNextNav"
              (click)="nextLesson()">arrow_right</mat-icon>
  </div>

  <router-outlet></router-outlet>
</section>

